// IMPORTANT
// This file takes the common searchForm settings (common to both flights and hotels in  'common/searchFormSettings') and extends by adding methods specific to HOME and MODIFY search forms
!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('common/searchForm',[], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module()
}('commonSearchForm', function(){
	
	return {
		changeCollectionImages : function() {
			var randNum = Math.floor((Math.random()*6)+1);
			var imgSrc = '//ui.cltpstatic.com/images/collections/assets/home_0'+randNum+'.jpg';
			$(".collectionUpsell").find("#collectionHomeImg").attr("src", imgSrc).end().show();
		}

	};
	
}, CT.settings);




		
		
		
		
